module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAAElBMVEUAAAB3d3d3d3d3d3d2dnZ4eHi78vF8AAAABXRSTlMAgEAgWK+cwC4AAAA1SURBVHja7cq3AYAwAAMw28D/L8NIT+/RLMQk/hMO3P7RJ8206uQrLThpJc305JNmEv8JVnYl0RA9zC5hLwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/paramIcon/空心方框_内点.png
// module id = +r2J
// module chunks = 2